import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProductSets } from "../../constants";

export const requestDeleteProductSet = async (setId: string): Promise<void> => {
  return await instance.delete(
    buildUrl(ApiRoutesProductSets.ProductSets, setId)
  );
};
